import { render, staticRenderFns } from "./keyConfigDialog.vue?vue&type=template&id=77c8210d&scoped=true&"
import script from "./keyConfigDialog.vue?vue&type=script&lang=js&"
export * from "./keyConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./keyConfigDialog.vue?vue&type=style&index=0&id=77c8210d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c8210d",
  null
  
)

export default component.exports